import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-subir-evento',
  templateUrl: './subir-evento.component.html',
  styleUrls: ['./subir-evento.component.scss']
})
export class SubirEventoComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<SubirEventoComponent>
  ) { }

  ngOnInit() {
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
